import { DefaultState, DropdownItem } from 'store/types';
import { Filters } from 'store/types';

export const GET_RESERVATION_PROVIDER_SELECT_LIST_REQUEST = 'GET_RESERVATION_PROVIDER_SELECT_LIST_REQUEST';
export const GET_RESERVATION_PROVIDER_SELECT_LIST_SUCCESS = 'GET_RESERVATION_PROVIDER_SELECT_LIST_SUCCESS';
export const GET_RESERVATION_PROVIDER_SELECT_LIST_FAILURE = 'GET_RESERVATION_PROVIDER_SELECT_LIST_FAILURE';

export interface ReservationProviderSelectListParams {
  filters: Filters;
  paging: {
    page: number;
    pageSize: number;
  };
};

export interface ReservationProviderSelectListData {
  rows: DropdownItem[];
  totalCount: number;
}

export type GetReservationProviderSelectListState = DefaultState & {
  contents?: ReservationProviderSelectListData;
};

interface ReadGetReservationProviderSelectListRequest {
  type: typeof GET_RESERVATION_PROVIDER_SELECT_LIST_REQUEST;
};

interface ReadGetReservationProviderSelectListSuccess {
  type: typeof GET_RESERVATION_PROVIDER_SELECT_LIST_SUCCESS,
  contents: ReservationProviderSelectListData;
}

interface ReadGetReservationProviderSelectListFailure {
  type: typeof GET_RESERVATION_PROVIDER_SELECT_LIST_FAILURE;
}

export type GetReservationProviderSelectListActionTypes = ReadGetReservationProviderSelectListRequest | ReadGetReservationProviderSelectListSuccess | ReadGetReservationProviderSelectListFailure;